<template>
  <div class="c-nav-dropdown__links nav-with-icon">
    <sc-image v-if="fields && fields.icon" :media="fields.icon" class="c-nav-dropdown__icon" />
    <sc-text
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-nav-dropdown__headline"
    />
    <div class="c-link-list" :class="{ 'c-link-list-half': !fields.listFullWidth.value }">
      <sc-placeholder name="jss-link" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Image, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-LinkSection',
  components: {
    ScText: Text,
    ScImage: Image,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-nav-dropdown__half {
  .c-nav-dropdown__links {
    &.nav-with-icon {
      .c-nav-dropdown__icon {
        transform: scale(0.85);

        @include desktop-up {
          left: -5.5rem;
          transform: scale(1);
        }
      }
    }
  }
}
</style>
